import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const TOKEN_KEY = "aria_admin_token";

export const adminApi = axios.create({ baseURL: `${BACKEND_URL}/api` });

adminApi.interceptors.request.use((config) => {
  const token = localStorage.getItem(TOKEN_KEY);
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const auth = {
  getToken: () => localStorage.getItem(TOKEN_KEY),
  isAuthed: () => !!localStorage.getItem(TOKEN_KEY),
  setToken: (t) => localStorage.setItem(TOKEN_KEY, t),
  logout: () => localStorage.removeItem(TOKEN_KEY),
  login: async (email, password) => {
    const { data } = await adminApi.post("/auth/login", { email, password });
    localStorage.setItem(TOKEN_KEY, data.access_token);
    return data.user;
  },
  me: () => adminApi.get("/auth/me").then((r) => r.data),
};

export const cms = {
  list: (kind) => adminApi.get(`/admin/content/${kind}`).then((r) => r.data),
  create: (kind, body) => adminApi.post(`/admin/content/${kind}`, body).then((r) => r.data),
  update: (kind, id, body) => adminApi.put(`/admin/content/${kind}/${id}`, body).then((r) => r.data),
  remove: (kind, id) => adminApi.delete(`/admin/content/${kind}/${id}`).then((r) => r.data),
};

export const mediaAdmin = {
  list: () => adminApi.get("/media", { params: { limit: 500 } }).then((r) => r.data),
  upload: (formData) => adminApi.post("/admin/media/upload", formData, { headers: { "Content-Type": "multipart/form-data" } }).then((r) => r.data),
  addVideo: (body) => adminApi.post("/admin/media/video", body).then((r) => r.data),
  update: (id, body) => adminApi.put(`/admin/media/${id}`, body).then((r) => r.data),
  remove: (id) => adminApi.delete(`/admin/media/${id}`).then((r) => r.data),
};

export const crm = {
  list: (status) => adminApi.get("/admin/inquiries", { params: status ? { status } : {} }).then((r) => r.data),
  stats: () => adminApi.get("/admin/inquiries/stats").then((r) => r.data),
  get: (id) => adminApi.get(`/admin/inquiries/${id}`).then((r) => r.data),
  update: (id, body) => adminApi.put(`/admin/inquiries/${id}`, body).then((r) => r.data),
  addNote: (id, text) => adminApi.post(`/admin/inquiries/${id}/note`, { text }).then((r) => r.data),
  generateProposal: (id) => adminApi.post(`/admin/inquiries/${id}/proposal`).then((r) => r.data),
  proposalPdfUrl: async (pid) => {
    const resp = await adminApi.get(`/admin/proposals/${pid}/pdf`, { responseType: "blob" });
    return URL.createObjectURL(resp.data);
  },
};
